
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M6.991.222s-.742.72-1.545 1.01C-.499 3.384 2.008 7.575 2.09 7.588c0 0 .334-.58.784-.911 2.858-2.101 3.438-4.52 3.438-4.52s-.64 2.91-3.183 4.721c-.562.4-.942 1.384-1.103 2.367 0 0 .398-.16.57-.204.066-.435.206-.853.442-1.225 3.553.423 4.716-2.44 4.868-3.438.36-2.358-.915-4.155-.915-4.155z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.222 .222)","d":"M0 0h9.022v9.022H0z"}})])])])
          )
        }
      }
    